import { ReactComponent as Spinner } from '../../icons/loader.svg';

import './page-loader.scss';

export const PageLoader = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="page-loader">
        <Spinner width={48} height={48} />
      </div>
    );
  }

  return <>{children}</>;
};
